import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import { getToken,removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
import router from '@/router'

//请求超时时间
axios.defaults.timeout = 60000;
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
//配置请求头
axios.defaults.headers.post['Content-Type'] = 'application/json'

//请求拦截器
axios.interceptors.request.use(
    config => {
        if (getToken()) {
        //   config.headers['Authorization'] = getToken()
          config.headers['pcToken'] = getToken()
        }
        // 防止缓存，GET请求默认带_t参数
        // if (config.method === 'get') {
        //     config.params = {
        //         ...config.params,
        //         ...{ '_t': new Date().getTime() }
        //     }
        // }
        config.headers['language'] = localStorage.getItem('change-language') || 'zh-CN'
        // config.transformRequest = [function (data) {
        //     //在请求之前可对data传参进行格式处理
        //     if (/^application\/json/.test(config.headers['Content-Type'])) {
        //         if (config.method === 'post' || config.method === 'put') {
        //             return JSON.stringify(data)
        //         }
        //     }

        //     return data
        // }]
        // get序列化
        config.paramsSerializer = function (params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
        }
        return config;
    },
    error => {
        return Promise.reject(error)
    }
)

const removeFun = () => {
	store.dispatch('loginOut')
}

//响应拦截器
axios.interceptors.response.use(
    res => {
        // console.log('响应拦截器',res);
        if(res.config.url.includes("/misnPc/deepseek/chat")){
            return Promise.resolve(res)
        } else {
            const status = res.status

            if (status === 200) {
                const code = res.data.code
                if (code == 0) {
                    //成功数据
                    return Promise.resolve(res.data)
                } else if (Object.prototype.toString.call(res.data) == '[object Blob]') {
                    //下载文件成功
                    return Promise.resolve(res);
                } else if (Number(code) === 40100 || Number(code) == 40101) {
                    //登录过期
                    removeFun()
                } else {
                if (
                    (res.config.url.includes('/prod/category') && res.config.method === 'delete')
                    || (res.config.url.includes('/prod/brand') && res.config.method === 'delete')
                ) {
                    return Promise.reject(res.data);
                } else if (
                    // 导出
                    (res.config.url.includes('/order/export') && res.config.method === 'get')
                ) {
                    return Promise.resolve(res.data)
                } else {
                    Message({
                        message: res.data.message || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    })
                }
                
                return Promise.reject(res.data);
                }
            } else if (status === 401) {
                // token失效
                removeFun()
            } else {
                // 服务器状态码不是200的情况
                return Promise.reject(error)
            }
        }
    }, error => {
        //请求失败
        console.log('打印错误：：-',error.response.status);
        if (error.response.status == 401) {
            // token失效
            removeFun()
        } else {
            Message({
                message: '请求失败',
                type: 'error',
                duration: 5 * 1000
              })
        }
        return Promise.reject(error)
    }
)

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res)
            }, err => {
                reject(err.data)
            })
            .catch(err => {
                reject(err.data)
            })
    })
}


/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
    let config = {
        headers: { "Content-Type": "application/json" },
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err.data || err)
            })
            .catch(err => {
                reject(err.data || err)
            })
    })
}

export function postStream(url, params) {
    let config = {
        headers: {"Content-Type": "application/json",'Accept':'text/event-stream'},
        responseType:'stream',
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err.data || err)
            })
            .catch(err => {
                reject(err.data || err)
            })
    })
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
    let config = {
        headers: { "Content-Type": "application/json" },
    }
    return new Promise((resolve, reject) => {
        axios.put(url, params, config)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err.data)
            })
            .catch(err => {
                reject(err.data)
            })
    })
}

/**
 * delete方法，对应delete请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function delet(url, params) {
  let config = {
    headers: { "Content-Type": "application/json" },
  }
    return new Promise((resolve, reject) => {
        axios.delete(url, params,config)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err)
            })
            .catch(err => {
                reject(err)
            })
    })
}

//文件上传
export function upload(url, params, onProgress, cancelToken) {
    // 假设上传速度是 1MB/s
    const uploadSpeed = 1 * 1024 * 1024; // 每秒 1MB (单位是字节)
    let timeout = 1000 * 60 * 20;
    // 如果 params 是 FormData 并且包含文件
    if (params && params instanceof FormData && params.has('file')) {
        const file = params.get('file');
        if (file && file.size) {
            // 计算超时时间（秒），文件大小 / 上传速度
            timeout = file.size / uploadSpeed * 1000; // 转换为毫秒
            timeout += 1000 * 60 * 5 // 加上5分钟的安全时间
            console.log('时间:',timeout)
        }
    }
    let config = {
        headers: { "Content-Type": "multipart/form-data" },
        // 如果有传递 cancelToken，则在请求配置中加入它
        cancelToken: cancelToken ? cancelToken.token : null,
        onUploadProgress: function (progressEvent) {
            if (progressEvent.lengthComputable) {
                let progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                // 调用进度回调函数（如果传递了）
                if (onProgress) onProgress(progress);
            }
        },
        timeout: timeout // 设置超时时间
    }
    return new Promise((resolve, reject) => {
        axios.post(url, params, config)
            .then(res => {
                resolve(res)
            }, err => {
                reject(err.data)
            })
            .catch(err => {
                if (axios.isCancel(err)) {
                    reject({ message: 'Upload canceled' });
                } else {
                    reject(err.response ? err.response.data : err);
                }
            })
    })
}

/**
 * post下载，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function download(url, params) {
    let config = {
        headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            'Download-Request': 'Download-Request', //多加的请求头
        },
        responseType: 'blob',
    };
    return new Promise((resolve, reject) => {
        axios
            .get(url, params, config)
            .then(
                (res) => {
                    resolve(res);
                },
                (err) => {
                    reject(err.data || err);
                }
            )
            .catch((err) => {
                reject(err.data || err);
            });
    });
}


export function downloadBlob(url, params) {
  let config = {
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Download-Request': 'Download-Request', //多加的请求头
    },
    responseType: 'blob',
  };
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, config)
      .then(
        (res) => {
          resolve(res);
        },
        (err) => {
          reject(err.data || err);
        }
      )
      .catch((err) => {
        reject(err.data || err);
      });
  });
}
